/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantWorkweekConfiguration} from '../api'

 export const useQueryGetMerchantWorkweekConfiguration = createReactQueryHook('getMerchantWorkweekConfiguration', getMerchantWorkweekConfiguration)
